/* PAVEMOM — size guide popup (delegated, works from accordion row or button) */
(function () {
  'use strict';
  var lastFocus = null;

  function getModal() { return document.querySelector('[data-sizeguide]'); }

  function open() {
    var modal = getModal();
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sizeguide-open');
    var c = modal.querySelector('.sizeguide__close');
    if (c) c.focus();
  }
  function close() {
    var modal = getModal();
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sizeguide-open');
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sizeguide-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-sizeguide-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    var modal = getModal();
    if (!modal || !modal.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = modal.querySelectorAll('button, a[href]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
